import { 
	REQUESTING
} from '../constants';
import Errors from '../errors';


export const requestError = (type,error,message=Errors.SomethingErrorHappens) => ({
	type,
	payload : { 
		fetchingState : REQUESTING.FAIL,
		error,
		message
	}
});

